import axios from "axios";
import { baseURL } from "../constants/const";

const instance = axios.create({
  baseURL: baseURL,
});

export const getUsers = async (accessToken) => {
  try {
    const response = await instance.get(baseURL + '/get-users', {
      params: {
        accessToken: accessToken
      },
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const getUser = async (accessToken, id) => {
  try {
    const response = await instance.get(baseURL + '/get-user', {
      params: {
        accessToken: accessToken,
        id : id
      },
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching user:', error);
    throw error;
  }
};

export const editUser = async (params) => {
  try{
    console.log("params", params);

    const response = await instance.post(baseURL + '/edit-user', params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      }
      });
      return response;
  }
  catch (error) {
    console.error('Error:', error);
    throw error;
  }
};

export const addUser = async (params) => {
  try{
    const response = await instance.post(baseURL + '/add-user', params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
    });
    return response;
  }
  catch (error) {
    console.error('Error:', error);
    throw error;
  }
};

export const deleteUser = async (params) => {
  try {
    const response = await instance.post(`${baseURL}/delete-user`, params, {
      headers: { 
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPagePermissions = async (accessToken) => {
  try {
    const response = await instance.get(baseURL + '/page-perm', {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      params: new URLSearchParams({ accessToken })
    });
    return response.data.permissions;
  } catch (error) {
    console.error('Error fetching page permissions:', error);
    throw error;
  }
};
  
export const getPartPermissions = async (accessToken, pageName) => {
    try {
      const response = await instance.get(baseURL + '/page-part-perm', {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        params: new URLSearchParams({ accessToken, page_name: pageName })
      });
      return response.data.permissions;
    } catch (error) {
      console.error('Error fetching page part permissions:', error);
      throw error;
    }
  };

  export const getEncryptionKey = async () => {
    try {
      const response = await instance.get(baseURL + '/enc-key', {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      });
      return response.data.key;
    } catch (error) {
      console.error('Error fetching key:', error);
      throw error;
    }
  };

  export const checkAuth = async (accessToken) => {
     
    if (accessToken) {
        try {
            const params = new URLSearchParams();
            params.append('accessToken', accessToken);

            const response = await instance.post(baseURL + '/auth-check', params, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            });

            if (response.status === 200) {
                const isValid = response.data.isValid;
                return isValid;
            }
        } catch (error) {
            console.error('Error during auth check:', error);
            throw error; 
        }
    } else {
        throw new Error('No access token provided');
    }
};

export const getReports = async (param) => {
  try {

    const response = await instance.get(baseURL + '/report_v1', {
      params: {
        accessToken: param.accessToken,
        startDate: param.startDate,
        endDate: param.endDate
      },
      headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
      }
  });
    return response.data;
  } catch (error) {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          console.error('Error 401: Invalid token or token not provided.');
          break;
        case 405:
          console.error('Error 405: Request method not allowed. Please use POST.');
          break;
        case 400:
          console.error('Error 400: Missing required parameters.');
          break;
        default:
          console.error(`Error ${error.response.status}: ${error.response.statusText}`);
      }
    } else {
      console.error('Network error or server did not respond.');
    }
    return null;
  }
};

export const getOrg = async (accessToken) => {
  try {
    const response = await instance.get(baseURL + '/get-org', {
      params: {
        accessToken: accessToken
      },
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return response;
  } catch (error) {
    console.error('Error fetching user:', error);
    throw error;
  }
};

export const getEmployees = async (accessToken) => {
  try {
    const response = await instance.get(baseURL + '/get-employees', {
      params: {
        accessToken: accessToken
      },
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    console.log(response);
    return response;
  } catch (error) {
    console.error('Error fetching user:', error);
    throw error;
  }
};